import { Tab } from "../../../../Shared/Tabs/Tab/Tab";
import { TabIcon, TabIconTypes } from "../../../../Shared/Tabs/Tab/TabIcon";
import { TabLabel } from "../../../../Shared/Tabs/Tab/TabLabel/TabLabel";
import { Tabs } from "../../../../Shared/Tabs/Tabs";
import { EDSBadge } from "../../../../eds/EDSBadge";

export type DiaryTabsProps = {
  sections: DiarySection[];
  selectedSectionKey: string;
  collapseButton?: any;
  direction?: "vertical" | "horizontal";
};

export type DiarySection = {
  key: string;
  icon: TabIconTypes;
  size?: "sm" | "md" | "lg";
  title: string;
  direction?: string;
  onClick: any;
  content?: any;
  count: number;
  showFilter: boolean;
  initialFilterQuery?: any;
  isEnabled: boolean;
};

export const DiaryTabs = ({
  direction = "horizontal",
  collapseButton,
  sections,
  selectedSectionKey
}: DiaryTabsProps) => {
  return (
    <Tabs direction={direction} type="secondary">
      {sections.map((section: DiarySection) =>
        section.isEnabled ? (
          <Tab
            size={section.size || "md"}
            key={section.title}
            active={section.key === selectedSectionKey}
            onClick={section.onClick}
          >
            {section.content ? (
              section.content
            ) : (
              <>
                {section.count > 0 && (
                  <EDSBadge
                    variant="default"
                    className="TabBadge absolute top-0.5 right-0 text-[10px] font-bold !px-[3px] !py-0 min-w-5 min-h-[10px] rounded-md"
                  >
                    {section.count}
                  </EDSBadge>
                )}
                <TabIcon name={section.icon} />
                <TabLabel>{section.title}</TabLabel>
              </>
            )}
          </Tab>
        ) : (
          ""
        )
      )}
      {collapseButton ? (
        <>
          <div className="DiaryTabs__filler flex-grow"></div>
          <Tab size="sm" useButton={false}>
            {collapseButton}
          </Tab>
        </>
      ) : (
        ""
      )}
    </Tabs>
  );
};
